import { SESSION_KEY_JWT } from '../../constants';
import { eventsRequest } from '../../utils/eventsRequest';

const removeAllItemsFromCart = async () => {
    try {
        const jwtToken = localStorage.getItem(SESSION_KEY_JWT);
        if (!jwtToken) {
            return false;
        }
        
        const response = await eventsRequest(`/cart`, 'delete');

        if (response.status === 200) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export default removeAllItemsFromCart;
